import { defaultRangesViewState } from '../../hooks/useActiveSpectrumRangesViewState';
import { getActiveSpectrum } from './getActiveSpectrum';
export function setRangesViewProperty(draft, key, value) {
    const rangesView = draft.view.ranges;
    const activeSpectrum = getActiveSpectrum(draft);
    if (!activeSpectrum?.id)
        return;
    const id = activeSpectrum.id;
    initializeRangeViewObject(draft, id);
    rangesView[id][key] =
        typeof value === 'function' ? value(rangesView[id][key]) : value;
}
export function initializeRangeViewObject(draft, spectrumID) {
    const rangesView = draft.view.ranges;
    if (spectrumID in rangesView)
        return;
    const defaultRangesView = { ...defaultRangesViewState };
    rangesView[spectrumID] = defaultRangesView;
}
